module.exports = __webpack_public_path__ + "img/Kevin.1252b2fd.jpeg";